// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { EmployeeNameResponse } from './employee-name-response';

/** See com.rev360.pms.api.controller.admin.employee.AdminEmployeeLimitedResponse */
/* istanbul ignore next */
@GandalfModel
export class AdminEmployeeLimitedResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	employeeId!: number | null;

	@GandalfProperty({ designType: EmployeeNameResponse })
	employeeName!: EmployeeNameResponse | null;

	@GandalfProperty({ designType: String })
	primaryLocationName!: string | null;

	@GandalfProperty({ designType: String })
	username!: string | null;

}
